import SPOTIFY_LOGO from '../../../icons/spotify/Spotify_Icon_RGB_Green.png';
import DEEZER_LOGO from '../../../icons/deezer/Deezer_Logo_RVB_Black.svg';

// eslint-disable-next-line import/prefer-default-export
export const icons = {
  spotify: SPOTIFY_LOGO,
  deezer: DEEZER_LOGO,
};
